import "../bot.scss";
import errorSteps from "./errorSteps";
import pagamentoPixSteps from "./pagamento/pagamentoPixSteps";
import pagamentoBoletoSteps from "./pagamento/pagamentoBoletoSteps";
import pagamentoCartaoSteps from "./pagamento/pagamentoCartaoSteps";
import cepErrorSteps from "./cepErrorSteps";
import copySteps from "./copySteps";
import leadSteps from "./leadSteps";
import proposalSteps from "./proposalSteps";
import pagamentoSteps from "./pagamento/pagamentoSteps";
import researchSteps from "./researchSteps";
import cupomSteps from "./cupomSteps";
import insuranceSteps from "./insuranceSteps";
import resumeSteps from "./resumeSteps";

const steps = [
  ...resumeSteps,
  ...copySteps,
  ...leadSteps,
  ...proposalSteps,
  ...pagamentoSteps,
  ...researchSteps,
  ...pagamentoCartaoSteps,
  ...pagamentoPixSteps,
  ...pagamentoBoletoSteps,
  ...errorSteps,
  ...cepErrorSteps,
  ...cupomSteps,
  ...insuranceSteps,
];

export default steps;
